import { render, staticRenderFns } from "./AnimatedBraindate.vue?vue&type=template&id=36f8693d&scoped=true&"
import script from "./AnimatedBraindate.vue?vue&type=script&lang=js&"
export * from "./AnimatedBraindate.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedBraindate.vue?vue&type=style&index=0&id=36f8693d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8693d",
  null
  
)

export default component.exports